//
// Password entry dialog.
//
// Params must have the following callback:
//   onConfirm(username, onceword) - callback on Confirm
//       username - user login id
//       onceword - SHA256 has of user's password
//
//   onCancel() - callback on Cancel
//
import 'bootstrap/dist/js/bootstrap.min.js';
import Modal from "react-bootstrap/Modal";
import { useState } from 'react';

import gUtilities from '../script/utilities';

const PromptPasswordDialog = (params) => {
    const [isOpen, setIsOpen] = useState(true);

    const hideModal = () => {
        setIsOpen(false);
    };

    async function onConfirm() {
        let widget;

        widget = document.getElementById("w_VerifyUsername");
        let username = widget.value;

        widget = document.getElementById("w_VerifyPassword");
        let password = widget.value;

        let onceword = await gUtilities.sha256(password);

        try {
            params.onConfirm(username, onceword);
        } catch (ex) {
            gUtilities.showError("Verify", "Operation failed (callback) " + ex.toString());
        }

        hideModal();
    }

    function onCancel() {
        try {
            if (params.onCancel) {
                params.onCancel();
            }
        } catch (ex) {
            gUtilities.showError("Verify", "Operation failed (callback) " + ex.toString());
        }

        hideModal();
    }

    return (
        <div>
            <Modal show={isOpen}>
                <div className="modal-content">
                    <div className="modal-header text-danger">
                        <h5 className="modal-title text-danger">Please Verify Your Password</h5>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="col-form-label mt-4" htmlFor="w_VerifyUsername">Username</label>
                            <input type="input" className="form-control" placeholder="" id="w_VerifyUsername"></input>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="col-form-label mt-4" htmlFor="w_VerifyPassword">Password</label>
                            <input type="password" className="form-control" placeholder="" id="w_VerifyPassword"></input>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={onConfirm}>Confirm</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default PromptPasswordDialog;